// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"b1e82941","453":"f8bc8a62","800":"92c4ec29"}[chunkId] + ".chunk.js";
};